<template>
  <div class="ty-main">
    <div class="tip">
        <el-button class="fr mb20" type="primary" @click="openAddRole" v-auth="['roleAdd']">添加角色</el-button>
    </div>
    <div class="ty-content white">
      <el-table :data="tableData" style="width: 100%" id="table">
        <el-table-column prop="role_name" label="角色名称" fixed width="194">
           <template slot-scope="scope">
              <div v-if="scope.row.role_name !== null && scope.row.role_name.length > 0">
                <el-popover
                  v-if="scope.row.role_name.length > 10"
                  placement="top-start"
                  popper-class="popperBox"
                  trigger="hover">
                  <div>{{scope.row.role_name}}</div>
                  <span slot="reference" style="color: #303133;">{{scope.row.role_name | ellipsis}}</span>
                </el-popover>
                <span v-else>{{scope.row.role_name}}</span>
              </div>
              <span v-else>-</span>
            </template>
        </el-table-column>
        <el-table-column label="角色描述" width="474">
          <template slot-scope="scope">
            <div v-if="scope.row.description !== null && scope.row.description.length > 0">
              <el-popover
                v-if="scope.row.description !== null && scope.row.description.length > 30"
                placement="top-start"
                popper-class="popperBox"
                trigger="hover">
                <div>{{scope.row.description}}</div>
                <span slot="reference" style="color: #303133;">{{scope.row.description | ellipsissss}}</span>
              </el-popover>
              <span v-else>{{scope.row.description}}</span>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="updated_at" label="创建时间" min-width="180px;">
          <template slot-scope="scope">
            <div class="okm">{{scope.row.updated_at ? scope.row.updated_at : '-'}}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="200">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.role_type !== 1"
              type="text"
              @click="$router.push({
                  path: '/setting/auth-list/', query: { code: scope.row.code, time: scope.row.updated_at }
                })"
              v-auth="['roleSetting']"
              >权限设置</el-button
            >
            <el-divider v-if="scope.row.role_type !== 1" direction="vertical"></el-divider>
            <el-button  v-if="scope.row.role_type !== 1" type="text" @click="roleEdit(scope.row)" v-auth="['roleEdit']"
              >编辑</el-button
            >
            <el-divider v-if="scope.row.role_type !== 1" direction="vertical"></el-divider>
            <el-button v-if="scope.row.role_type !== 1" type="text" @click="handleDelete(scope.row.code)" v-auth="['roleDel']"
              >删除</el-button
            >
          </template>
        </el-table-column>
         <template #empty>
          <el-empty v-loading="loading"></el-empty>
        </template>
      </el-table>

      <div class="toolbar">
        <div></div>
        <el-pagination
          background
          @current-change="currentChange"
          :current-page="currentPage"
          :page-size="pagesize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>

      <el-dialog :title="title" width="622px" :show-close="false" :visible.sync="isAddDialog" :close-on-click-modal="false" :before-close="clearRoleForm">
        <el-form
          class="dialog-form"
          :model="roleForm"
          :rules="rules"
          label-width="120px"
          ref="roleForm"
        >
          <el-form-item label="角色名称:" prop="roleName">
            <el-input placeholder="请输入角色名称" clearable v-model="roleForm.roleName" maxlength="15" show-word-limit style="widthL 424px;"></el-input>
          </el-form-item>
          <el-form-item label="角色描述:" prop="description">
            <el-input placeholder="请输入角色描述" clearable v-model="roleForm.description" width="424px"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="info" plain @click="resetForm('roleForm')">取消</el-button>
          <el-button type="primary" @click="confirmEditRole('roleForm')">保存</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      tableData: [],
      total: 0,
      title: '添加角色',
      code: '',
      loading: false,
      isAddDialog: false,
      roleForm: {},
      rules: {
        roleName: [{ required: true, message: '请输入角色名称', trigger: 'blur' }]
      },
      time: ''
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    // 表数据
    getList() {
      this.loading = true
      const parms = {
        code: this.code,
        page: this.currentPage
      }
      this.$api.get('/api/system/role/index', parms).then(res => {
        this.total = res.total
        this.tableData = res.data
        this.loading = false
      })
    },
    currentChange(val) {
      this.currentPage = val
      this.getList()
    },
    // 添加修改
    confirmEditRole(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const { code, roleName, description } = this.roleForm
          this.$api
            .post('/api/system/role/edit', {
              code: code,
              name: roleName,
              description: description,
              role_look: 5,
              lastUpdateTime: this.time
            })
            .then(res => {
              this.getList()
              this.isAddDialog = false
              this.$message({
                message: `${code ? '编辑' : '添加'}角色成功！`,
                type: 'success'
              })
              this.roleForm = {}
            })
        }
      })
    },
    resetForm(formName) {
      this.isAddDialog = false
      this.$refs[formName].resetFields()
    },
    openAddRole() {
      this.isAddDialog = true
      this.title = '添加角色'
      this.roleForm = {}
    },
    roleEdit(row) {
      this.title = '编辑角色'
      this.isAddDialog = true
      this.time = row.updated_at
      this.roleForm = {
        code: row.code,
        roleName: row.role_name,
        description: row.description
      }
    },
    handleDelete(code) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false,
        closeOnClickModal: false
      })
        .then(() => {
          this.$api
            .post('/api/system/del/role', {
              code: code
            })
            .then(res => {
              this.getList()
              this.$message.success('删除成功！')
            })
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    clearRoleForm(done) {
      this.roleForm = {}
      done()
    }
  }
}
</script>

<style lang="scss" scoped>
.tip {
    height: 80px;
    text-align:right;
    padding: 0 20px;
    background: #ffffff;
    box-shadow: 0px 2px 8px rgb(2 47 50 / 8%);
    opacity: 1;
    font-size: 14px;
    border-radius: 2px;
    margin-bottom: 20px;
    .mb20{
      position:relative;
      top:20px;
    //  left:1560px;
      float: right;
      height: 40px;
      background: #204A9E;
      opacity: 1;
      border-radius: 4px;
    }
}
::v-deep .el-dialog__body {
  padding-top: 30px;
  padding-bottom: 10px;
  padding-left: 30px;
  padding-right: 30px;
}
::v-deep .el-dialog .el-dialog__title{
  border: none;
}
.fgfj{
  display:none;
}
::v-deep .el-button--primary{
  letter-spacing: 0;
}
::v-deep .el-button--primary:hover{
  background: #295FB4;
  color: #fff;
}
::v-deep .el-form-item__content{
  width: 424px;
}
::v-deep .el-form-item__error{
  position: absolute;
  top: 38px;
}
</style>
